// extracted by mini-css-extract-plugin
export default {"is-generated-response":"components-hotel-reviews-review-detail-response-module__is-generated-response"};